import React, { Component } from 'react'

import DeIcingLiquid from '../block/DeIcingLiquid'
import Partners from '../block/Partners'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data
    const { showWindow } = this.props

    return (
      <>
        <DeIcingLiquid data={data} showWindow={showWindow} />
        <Partners data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App